module.exports = __webpack_public_path__ + "media/images/contest-voted-story-f17719a677d4d9d8d460ab06b362671f.png";